import {useEffect, useRef, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/toolbar/Toolbar'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import ResetPassword from '../../app/pages/login/ResetPassword'
import {
  DrawerMessenger,
  ActivityDrawer,
  InviteUsers,
  UpgradePlan,
  ThemeModeProvider,
} from '../partials'
import {MenuComponent} from '../assets/ts/components'
import {Footer} from './components/Footer'
import Cookies from 'universal-cookie'
import {useNavigate} from 'react-router-dom'
import {default as Apiservices} from '../../../src/common/index'
import {ToastContainer, toast} from 'react-toastify'
import {ThingsProvider} from '../../app/modules/apps/masters/commonicons/GlobalContext'
import {ValidProvider} from '../../app/modules/apps/masters/commonicons/ValidateContext'
import serverCredintials from '../../common/serverCredintials'

// const MasterLayout = () => {
export function MasterLayout(props: any) {
  const location = useLocation()
  const cookies = new Cookies()
  const navigate = useNavigate()
  const iframeRef: any = useRef(null)
  const [resetPassword, setresetPassword] = useState(false)
  const iframeSrc = serverCredintials.BuildURL.getTicketingWidgetURL()
  const [widgetToggle, setWidgetToggle] = useState(false)
  const [widgetShow, setWidgetShow] = useState(false)
  const [widgetShowPropKey, setWidgetShowPropKey] = useState()
  const [widgetRoute, setWidgetRoute] = useState('/')
  let business: any = localStorage.getItem('role_Name')
  const isLoggingOutRef = useRef(false)
  let numArray: any = business?.split(',')
  function removeAll() {
    let lRemove: any = [
      'token',
      'user_email',
      'org_list',
      'role_Name',
      'org_prefix',
      'org_id',
      'org_name',
      'tool_name',
      'ecdb_user_id',
      'userid',
      'Authorization',
      'NetSuiteToken',
      'enable_netsuite',
      'subsidary_name',
      'logged_in_id',
      'Announcement',
      'refresh_Token',
      'enable_quickbooks',
      'org_icon',
      'time_sheet_admin_screen_user_id',
      'MobileForceUpdateAccessbyEmail',
      'allowed_business_unit_id',
      'bu_list',
      'enable_unbilled',
      'invoice_access',
      'enable_email',
      'passwordExpiryDays',
      'passwordPopUpDays',
      'support',
      'is_pending_timesheet_submission',
      'is_timesheet_approval',
      'is_timesheet_rejection',
      'is_timesheet_reminder',
      'is_timesheet_submission',
    ]
    for (let each of lRemove) {
      localStorage.removeItem(each)
    }
  }
  useEffect(() => {
    const handleRouteChange = (location: any) => {
      if (window.localStorage.getItem('Authorization')) {
        const supportStr: any = localStorage.getItem('support')
        if (JSON.parse(supportStr)) {
          setWidgetShow(true)
        } else {
          setWidgetShow(false)
        }
      }
    }
    handleRouteChange(location)
  }, [location, widgetShowPropKey])

  useEffect(() => {
    const handleStorageChange = () => {
      // Check if the authentication data is missing (localStorage was cleared)
      if (!localStorage.getItem('Authorization')) {
        logout() // Call your logout logic
      }
    }

    // Add an event listener for changes in `localStorage`
    window.addEventListener('storage', handleStorageChange)

    // Cleanup the listener when the component unmounts
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])
  useEffect(() => {
    window.addEventListener('message', getWidgetMsg)
    return () => {
      window.removeEventListener('message', getWidgetMsg)
    }
  }, [])

  const getWidgetMsg = (event: any) => {
    if (event.data && event.data.app === 'widget') {
      setWidgetToggle(event.data.widgetShow)
      setWidgetRoute(event.data.url)
    }
  }

  const widgetReload = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage('reload', '*')
    }
  }
  const widgetLogout = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage('logout', '*')
    }
  }
  const logout = async () => {
    // if (issuesProjectLength > 0) {
    if (isLoggingOutRef.current) return // If logout is already in progress, do nothing.
    isLoggingOutRef.current = true // Set to true to prevent subsequent logout calls
    try {
      // Call your logout API
      const data: any = await Apiservices.getUserLogout()
      removeAll()
      widgetLogout()
      cookies.remove('JWT-TOkEN')
      cookies.remove('JWT_TOKEN')
      cookies.remove('org_id')
      cookies.remove('torg_id')
      cookies.remove('profileView')
      cookies.remove('tool_name')
      cookies.remove('ecdb_user_id')

      cookies.remove('JWT-TOkEN', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('JWT_TOKEN', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('org_id', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('torg_id', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('profileView', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('tool_name', {path: '/', domain: '.msrcosmos.com'})
      cookies.remove('ecdb_user_id', {path: '/', domain: '.msrcosmos.com'})

      // Show toast error for session expired
      toast.error('Session expired', {
        position: toast.POSITION.BOTTOM_LEFT,
      })
      // Redirect after a delay
      setTimeout(() => {
        navigate('/login')
      }, 1000)

      // Ensure we reset the flag and cleanup after toast is shown
      setTimeout(() => {
        isLoggingOutRef.current = false // Reset logout flag after toast delay
      }, 1000)
    } catch (error) {
      console.error('Error during logout:', error)
    } finally {
      isLoggingOutRef.current = false // Reset logout flag
    }
  }

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])
  // const getValidate = async () => {
  //   const res: any = await Apiservices.getValidate()
  //   if (!(res.data.statusCode == 200)) {
  //     issuesProjectLength += 1
  //     logout()
  //   }
  // }

  const getCookie = async (prm: any) => {
    let issuesProjectLength = 0
    if (prm == true || prm == false) {
      setWidgetShowPropKey(prm)
    }
    // const res: any = await Apiservices.getValidate()
    // if (res.data.statusCode == 200) {
    //   // cookies.set('JWT-TOkEN', res.accessToken, {path: '/', domain: '.msrcosmos.com'})
    //   // cookies.set('JWT_TOKEN', res.accessToken, {path: '/', domain: '.msrcosmos.com'})
    //   if (
    //     window.location.hostname === 'timesheets-uat.msrcosmos.com' ||
    //     window.location.hostname === 'timesheets.msrcosmos.com'
    //   ) {
    //     cookies.set('JWT-TOkEN', res.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
    //     cookies.set('JWT_TOKEN', res.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
    //   } else {
    //     cookies.set('JWT-TOkEN', res.data.accessToken)
    //     cookies.set('JWT_TOKEN', res.data.accessToken)
    //   }
    // }
    // if (!(res && res.data && res.data.statusCode == 200)) {
    //   if (issuesProjectLength == 0) {
    //     issuesProjectLength += 1
    //     logout()
    //   }
    //   // logout()
    // }
    let userId = parseInt(localStorage.getItem('ecdb_user_id') || '0', 10)
    const data123: any = await Apiservices.getChangePassword1(userId, {
      orgId: localStorage.getItem('org_id'),
      toolName: 'Timesheet Tracker',
    })
    if (data123.status == 200) {
      if (data123.data.passwordExpiryDays != localStorage.getItem('passwordExpiryDays')) {
        localStorage.setItem('passwordExpiryDays', data123.data.passwordExpiryDays)
        sessionStorage.setItem(
          'isPassKey',
          JSON.stringify(
            data123.data.passwordPopUpDays - 5 <= data123.data.passwordExpiryDays ? 'true' : 'false'
          )
        )
      }
    }
    if (
      (cookies.get('JWT-TOkEN') || cookies.get('JWT_TOKEN')) &&
      cookies.get('org_id') &&
      cookies.get('torg_id') == cookies.get('org_id')
    ) {
      const data1: any = await Apiservices.getSSO()
      if (data1 && data1.data && data1.data.statusCode == 200) {
        // cookies.set('JWT-TOkEN', data1.data.accessToken)
        // cookies.set('JWT_TOKEN', data1.data.accessToken)
        cookies.set('JWT-TOkEN', data1.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
        cookies.set('JWT_TOKEN', data1.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
      } else {
        logout()
      }
    } else if (
      (cookies.get('JWT-TOkEN') || cookies.get('JWT_TOKEN')) &&
      cookies.get('org_id') &&
      cookies.get('torg_id') != cookies.get('org_id')
    ) {
      navigate('OrganizationList')
    } else {
      const res: any = await Apiservices.getValidate()
      if (res.data.statusCode == 200) {
        if (
          window.location.hostname === 'timesheets-uat.msrcosmos.com' ||
          window.location.hostname === 'timesheets.msrcosmos.com'
        ) {
          cookies.set('JWT-TOkEN', res.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
          cookies.set('JWT_TOKEN', res.data.accessToken, {path: '/', domain: '.msrcosmos.com'})
        } else {
          cookies.set('JWT-TOkEN', res.data.accessToken)
          cookies.set('JWT_TOKEN', res.data.accessToken)
        }
      } else if (!(res && res.data && res.data.statusCode == 200)) {
        logout()
      }
    }

    if (data123.status == 200 && prm == 'vyshu') {
      return data123.data
    }
  }
  const handleDownload = async (url1: string) => {
    try {
      const token = localStorage.getItem('Authorization') // or however you store your JWT
      if (!token) {
        console.error('No authentication token found')
        return
      }
      const response: any = await fetch(url1, {
        method: 'GET',
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      if (!response.ok) {
        toast.warn(response.statusText)
        throw new Error(`Failed to download file: ${response.statusText}`)
      }
      // Get the filename from Content-Disposition header or use provided/default
      const contentDisposition = response.headers.get('Content-Disposition')
      let downloadFilename = 'Downloaded File'
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/)
        if (filenameMatch) {
          downloadFilename = filenameMatch[1]
        }
      }
      const blob = await response.blob()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', downloadFilename)
      document.body.appendChild(link)
      link.click()
      link.remove()
      // window.URL.revokeObjectURL(link.href)
    } catch (error) {
      console.error('Download failed:', error)
      // You can add toast notification or other error handling here
    }
  }

  const handleViewToken = async (url1: string) => {
    console.log(url1, 'url1')
    try {
      const token = localStorage.getItem('Authorization') // or however you store your JWT
      if (!token) {
        console.error('No authentication token found')
        return
      }
      const response: any = await fetch(url1, {
        method: 'GET',
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      if (!response.ok) {
        toast.warn(response.statusText)
        throw new Error(`Failed to download file: ${response.statusText}`)
      }
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      window.open(url, '_blank')
      // window.URL.revokeObjectURL(link.href)
    } catch (error) {
      console.error('Download failed:', error)
      // You can add toast notification or other error handling here
    }
  }

  const getValidate = (url: any, state1: any) => {
    if (state1 == 'view') {
      handleViewToken(url)
    } else if (state1 == 'download') {
      handleDownload(url)
    }
  }

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])
  const forcePasswordPopClose = () => {
    setresetPassword(false)
    sessionStorage.setItem('isPassKey', 'false')
  }

  return (
    <ValidProvider value={{getValidate: getValidate}}>
      <ThingsProvider value={{getCookie: getCookie}}>
        <PageDataProvider>
          <ThemeModeProvider>
            <div className='page d-flex flex-row flex-column-fluid'>
              <AsideDefault />
              <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
                <HeaderWrapper widgetReload={widgetReload} widgetLogout={widgetLogout} />

                <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                  <Toolbar />
                  <div className='post d-flex flex-column-fluid' id='kt_post'>
                    <Content>
                      <Outlet />
                    </Content>
                  </div>
                </div>
                {numArray?.includes('employee') && <Footer />}
                {widgetShow && (
                  <div
                    id='widget'
                    style={{
                      position: 'fixed',
                      right: '0',
                      bottom: '0',
                      zIndex: 9999,
                      width: widgetToggle ? '80vh' : '40px',
                      height: widgetToggle
                        ? ['/', '/intro'].includes(widgetRoute)
                          ? '580px'
                          : '750px'
                        : '40px',
                    }}
                  >
                    <iframe
                      ref={iframeRef}
                      src={iframeSrc}
                      title='widget'
                      style={{width: '100%', height: '100%', border: 'none'}}
                      allow='display-capture'
                    ></iframe>
                  </div>
                )}
                {resetPassword && <ResetPassword forcePasswordPopClose={forcePasswordPopClose} />}
              </div>
            </div>

            {/* begin:: Drawers */}
            <ActivityDrawer />
            <RightToolbar />
            <DrawerMessenger />
            {/* end:: Drawers */}

            {/* begin:: Modals */}
            <InviteUsers />
            <UpgradePlan />
            {/* end:: Modals */}
            <ScrollTop />
          </ThemeModeProvider>
        </PageDataProvider>
      </ThingsProvider>
    </ValidProvider>
  )
}

// export {MasterLayout}
